export default __webpack_public_path__ + "static/media/tableclothes.75a9f32d.svg";